import { createSelector } from 'reselect';
const rootSelector = (state) => state.adminCompanies;
export const currentCompanyIdSelector = createSelector(rootSelector, ({ currentCompanyId }) => currentCompanyId);
